import notify from '@scoutgg/ftw/source/services/notification'
import { prompt } from '@scoutgg/ftw/source/services/modal'
import Modal from '@scoutgg/ftw/source/services/modal'
import {Template, Component, Attribute} from '@scoutgg/ftw/source/lib'
import {Match, Lineup, Team} from '../../models'
import template from './edit-lineups.jade'
import '../status'
import '../team-picker'
import '../lineups'
import '@scoutgg/ftw/source/atoms/tabs/tabs'
import EditMatchSource from '../edit-match-source'
import EditFormations from '../edit-formations'
import { getSportPositions } from '../../models/concerns/position'

@Component('sporty')
@Template(template)
@Attribute('match', Match)
@Attribute('team', Team)
@Attribute('context', String)
@Attribute('all-teams', Boolean)
@Attribute('priced-only', Boolean)
export default class EditLineups extends HTMLElement {
  attached() {
    this.context = 'expected'
    this.pricedOnly = true
    this.matchChange()
  }

  count(lineups, team, isBench) {
    return lineups
      .filter(l => l.team === team && !l.isBench === !isBench)
      .length
  }

  addLineup({lineup}) {
    var index = (this.lineups || []).indexOf(lineup)
    if(index < 0) this.lineups.push(lineup)
    this.assignLineups()
  }

  removeLineup({lineup}) {
    var index = this.lineups.indexOf(lineup)
    if(index < 0) return
    this.lineups.splice(index, 1)
    this.assignLineups()
  }

  assignLineups() {
    const nodes = this.shadowRoot
      .querySelectorAll('sporty-team-picker, sporty-lineups')
    for(const node of nodes) {
      node.lineups = this.lineups
      node.render()
    }
    this.render()
  }

  async matchChange() {
    const data = this.match.load()
    this.update(data)
    if(!this.lineups) this.lineups = []
  }

  lineupsCountPerTeams(teams = [], status) {
    let lineups = []
    if(status === 'confirmed') {
      teams.forEach(team => {
        lineups = lineups.concat(this.lineupsForStatus(team, 'confirmed'))
      })
    } else {
      teams.forEach(team => {
        lineups = lineups.concat(this.lineupsForStatus(team))
      })
    }
    return lineups.reduce((initial, lineup) => {
      let playerPosition = lineup.player.position
      if(!initial.positions[playerPosition]) {
        initial.positions[playerPosition] = { total: 0 }
      }
      initial.total += 1
      initial.positions[playerPosition].total += 1
      return initial
    }, {
      total: 0,
      positions: {},
    })
  }

  lineupsForStatus(team, status) {
    return (this.lineups || [])
      .filter(l => status ? l.status === status && l.team === team : l.team === team)
      .sort((a, b) => {
        var posIndex =
          this.sportPositions.indexOf(a.player.position) -
          this.sportPositions.indexOf(b.player.position)
        return posIndex || (a.player.shirt - b.player.shirt)
      })
  }

  async autoExpect(players, existing) {
    const previous = this.previousLineups || {}
    const prices = {}
    for(const team of this.match.teams) {
      const data = await team.load({ season: this.match.seasonId })
      for(const price of (data.prices || [])) {
        prices[price.playerId] = price
      }
    }
    for(const player of players) {
      const price = prices[player]
      if(!price) continue
      if(price.disabled) continue

      const lineup = existing[player]
      const prev = previous[player]
      const status
        = !prev ? 'unexpected'
        : prev.status === 'confirmed' ? 'expected'
        : prev.status === 'bench' ? 'possible'
        : 'unexpected'

      if(lineup) {
        lineup.status = status
        continue
      }
      this.lineups.push(Lineup.create({
        match: this.match,
        player: player,
        team: player.team,
        status: status,
      }))
    }
  }

  autoConfirm(players, existing) {
    for(const player of players) {
      const lineup = existing[player]
      if(!lineup) continue
      lineup.status
        = ['confirmed', 'bench'].includes(lineup.status) ? lineup.status
        : lineup.status === 'expected' ? 'confirmed'
        : lineup.status === 'possible' ? 'bench'
        : 'refuted'
    }
  }

  async copyPrevious(context) {
    if(this.isCopyingPrevious) {
      return
    }
    this.isCopyingPrevious = true
    try {
      const existing = {}
      for(const lineup of (this.lineups || [])) {
        existing[lineup.player] = lineup
      }
      const players = (this.match.teams || []).flatMap(t => t.players)

      if(context === 'confirmed') {
        this.autoConfirm(players, existing)
      }
      if(context === 'expected') {
        await this.autoExpect(players, existing)
      }
      this.assignLineups()
    } catch(err) {
      console.error(err)
    } finally {
      this.isCopyingPrevious = false
    }
  }

  async fixDuplicates() {
    await prompt(`
      Are you sure you want to remove potentially duplicate lineups?
      Some stats you wanted may disappear!
    `, { type: 'yesno'})
    await this.match.post('fix-duplicates')
    notify('Duplicates fixed, hopefully!', { level: 'success', timeout: 5000})
    this.update(this.match.load({ $reload: true }))
  }

  selectTeam(value) {
    if(value === '$all-teams') {
      this.team = null
      this.allTeams = true
    } else if(value) {
      this.team = value
      this.allTeams = false
    } else {
      this.team = null
      this.allTeams = false
    }
  }

  swapTeam(lineup) {
    const index = lineup.match.teams.indexOf(lineup.team)
    lineup.team = lineup.match.teams[1 - index]
    this.render()
  }

  modalUrl(match) {
    return `/match-sources?season=${match.season._id}&match=${match._id}`
  }

  pricesUrl(match) {
    return `/Prices?season=${match.season._id}&match=${match._id}`
  }

  async openFormationsModal(match) {
    const awayStatus = this.lineupsForStatus(match.awayTeam, 'expected').length ? 'expected' : 'confirmed'
    const homeStatus = this.lineupsForStatus(match.homeTeam, 'expected').length ? 'expected' : 'confirmed'

    const edit = EditFormations({
      awayPlayers: this.lineupsForStatus(match.awayTeam, awayStatus).map(el => el.player),
      homePlayers: this.lineupsForStatus(match.homeTeam, homeStatus).map(el => el.player),
      season: match.season,
      match: match
    })
    const { match: savedMatch, teams, source } = await Modal(
      edit,
      { hideCloseBtn: false, width: '1400px' },
    )
    this.render()
    const status = this.shadowRoot.querySelector('sporty-status')
    status.render()
  }

  async openOverrideModal(match) {
    const edit = EditMatchSource({ season: match.season, match: match })
    const { match: savedMatch, teams, source } = await Modal(
      edit,
      { hideCloseBtn: true },
    )
    this.render()
    const status = this.shadowRoot.querySelector('sporty-status')
    status.render()
  }

  get refuted() {
    return Array.from(this.shadowRoot.querySelectorAll('sporty-team-picker'))
      .reduce((ret, el) => ret.concat(el.refuted), [])
  }

  get contexts() {
    return [
      'expected',
      'confirmed',
    ]
  }

  get statuses() {
    return [
      'confirmed',
      'bench',
      'expected',
      'possible',
      'unexpected',
      'suspended',
      'injured',
    ]
  }

  get sport() {
    return this.match && this.match.sport
  }

  get sportPositions() {
    return getSportPositions(this.sport)
  }

  get batches() {
    const { sport, match, context } = this
    if(!match) return []
    if(match.locations && match.locations.length) {
      let periods = []
      for(const location in match.locations) {
        periods.push([+location + 1])
      }
      return periods
    }
    if(match.isEsports) return [1,2,3,4,5]
    if(context !== 'confirmed') return [0]
    if(sport !== 'e_football') return [0]
    if(!match.periods) return [0]
    return match.batches
  }

  get lineupTeams() {
    const { match, team, allTeams } = this
    if(!(match && match.teams)) return []
    if(team) return [team]
    if(match.teams.length < 3) return match.teams
    if(allTeams) return match && match.teams
  }
}
